export enum ComponentTypes {
    /**
     * Główna część booking engine, okno booking engine, z routingiem itd
     */
    MainModal = 1,
    SubComponent = 2,
    SubComponentHost = 3

}